export const GoogleAnalyticsConstantsEvents = {
  ADD_DATA_: "add_data_",
  ADD_DATA_ARCGISRESTFS: "add_data_ArcGISRestFS",
  ADD_DATA_CLICK: "add_data_click",
  ADD_DATA_WFS: "add_data_WFS",
  ADD_DATA_WMS: "add_data_WMS",
  ADD_DATA_WMTS: "add_data_WMTS",
  ADD_DATA_VECTORTILE: "add_data_vectortile",
  ADD_DATA_XYZ: "add_data_XYZ",
  AI_SEARCH_PERFORMED: "ai_search_performed",
  BEFORE_AFTER_TOOL: "before/after_slider",
  CHANGE_MODE: "change_mode_to_",
  CHANGE_ORIENTATION: "change_orientation_",
  CLICK_IMAGE_IN_GALLERY: "click_image_in_gallery",
  CLICK_NEXT_ELEMENTS_PROPERTY_REPORT: "click_next_elements_property_report",
  CLICK_NEXT_ELEMENTS_DAMAGE_REPORT: "click_next_elements_damage_report",
  CUSTOM_ELEMENT_DETECTION_OBJECT: "custom_element_detection_object",
  CUSTOM_ELEMENT_DETECTION_SEARCH: "custom_element_detection_search",
  CUSTOM_ELEMENT_DETECTION_EXPORT: "custom_element_detection_export",
  CUSTOM_ELEMENT_DETECTION_TOGGLE_BBOX: "custom_element_detection_toggle_bbox",
  CUSTOM_ELEMENT_DETECTION_TOGGLE_MASK: "custom_element_detection_toggle_mask",
  CUSTOM_ELEMENT_DETECTION_BACK_TO_CONFIG: "custom_element_detection_back_to_config",
  DATA_SEARCH: "data_search",
  DOWNLOAD_ELEMENTS_PROPERTY_REPORT: "download_elements_property_report",
  DOWNLOAD_ELEMENTS_DAMAGE_REPORT: "download_elements_damage_report",
  DOWNLOAD_IMAGE: "download_image",
  DUAL_VIEW: "dual_view",
  DUAL_VIEW_COLLAPSE_TOOLBAR: "dual_view_collapse_toolbar",
  DRAWING_ONLY_COMPLETE: "drawing_only_complete",
  EXPORT_GEOMETRY_CLICK_TOOL: "export_geometry_click_tool",
  EXPORT_GEOMETRY_RIGHT_CLICK: "export_geometry_right_click",
  EXPORT_GEOMETRY_DOWNLOAD: "export_geometry_download_",
  EXPORT_GEOTIFF_OPEN_MULTIPLE_EXPORTS: "Export_GeoTIFF_open_multiple_exports",
  EXPORT_GEOTIFF_OPEN_TOOL: "Export_GeoTIFF_open_tool",
  EXPORT_GEOTIFF_CLICK_DOWNLOAD: "Export_GeoTIFF_click_download",
  EXPORT_GEOTIFF_CLICK_EXPORT_MULTIPLE: "Export_GeoTIFF_click_export_multiple",
  GET_ELEMENTS_DAMAGE_ASSESSMENT: "get_elements_damage_assessment",
  GET_ELEMENTS_PROPERTY_INFO: "get_elements_property_info",
  GRAY_SKY_CONTRAST_ON: "gray_sky_contrast_on",
  GRAY_SKY_CONTRAST_OFF: "gray_sky_contrast_off",
  IMAGE_GALLERY: "image_gallery",
  IMAGE_GALLERY_CLICK_IMAGE: "image_gallery_click_image",
  IMAGE_GALLERY_DATA_FILTER: "image_gallery_data_filter",
  IMAGE_GALLERY_YEAR_FILTER: "image_gallery_year_filter",
  INFRARED_STATUS: "infrared_status",
  LOCATION_SEARCH_BAR: "location_search_bar",
  MEASUREMENT_COMPLETED: "_measurement_completed",
  MEASUREMENT_CHANGE_UNITS: "measurement_change_units",
  MEASUREMENT_CLEAR_WORKSPACE: "measurement_clear_workspace",
  MEASUREMENT_EDIT_COLOR: "measurement_edit_color",
  MEASUREMENT_EDIT_FEATURE: "measurement_edit_feature",
  MEASUREMENT_DRAG_FEATURE: "measurement_drag_feature",
  MEASUREMENT_SHOW_OR_HIDE_VALUES: "measurement_show_or_hide_values",
  MEASUREMENT_UNDO_SHAPE: "measurement_undo_shape",
  MY_DATA_EDIT_STYLE: "my_data_edit_style",
  MY_DATA_NEXT_LOCATION_ARROW: "my_data_next_location_arrow",
  MY_DATA_OPEN_LIST_VIEW: "my_data_open_list_view",
  MY_DATA_HIGHLIGHT_ON_MAP: "my_data_highlight_on_map",
  MY_DATA_OPEN_PIF_X_DAMAGE_ASSESSMENT: "my_data_open_pif_x_damage_assessment",
  MY_DATA_OPEN_PIF_X_PROPERTY_INFORMATION: "my_data_open_pif_x_property_information",
  MY_DATA_PREVIOUS_LOCATION_ARROW: "my_data_previous_location_arrow",
  MY_DATA_REMOVE: "my_data_remove",
  MY_DATA_REVIEW_PIF_X_DAMAGE_ASSESSMENT: "my_data_review_pif_x_damage_assessment",
  MY_DATA_REVIEW_PIF_X_PROPERTY_INFORMATION: "my_data_review_pif_x_property_information",
  MY_DATA_START_PROCESSING_PIF_X_DAMAGE_ASSESSMENT: "my_data_start_processing_pif_x_damage_assessment",
  MY_DATA_START_PROCESSING_PIF_X_PROPERTY_INFORMATION: "my_data_start_processing_pif_x_property_information",
  MY_DATA_ZOOM_TO_FEATURE: "my_data_zoom_to_feature",
  OPEN_IMAGE_GALLERY: "open_image_gallery",
  OVERLAYS_WIDGET_EXPAND: "overlays_widget_expand",
  OVERLAYS_WIDGET_COLLAPSE: "overlays_widget_collapse",
  OVERLAYS_WIDGET_IMAGERY: "overlays_widget_imagery",
  OVERLAYS_WIDGET_BASEMAP: "overlays_widget_basemap",
  PAN_DRAG_MAP: "pan_drag_map",
  REQUEST_ELEMENTS_PROPERTY_OPEN_FORM: "request_elements_property_report_open_form",
  RIGHT_CLICK_GET_INFO: "right_click_get_info",
  RIGHT_CLICK_CENTER_MAP_HERE: "right_click_center_map_here",
  RIGHT_CLICK_COPY_COORDINATES: "right_click_copy_coordinates",
  RIGHT_CLICK_ZOOM_IN: "right_click_zoom_in",
  RIGHT_CLICK_ZOOM_OUT: "right_click_zoom_out",
  SHOW_INFO_CARD: "show_info_card",
  SCREENSHOT: "screenshot",
  TIMELINE_AOI_BLUE_SKY: "timeline_aoi_blue_sky",
  TIMELINE_AOI_GRAY_SKY: "timeline_aoi_gray_sky",
  TIMELINE_CHANGE_AOI: "timeline_change_aoi",
  TIMELINE_FILTER_OPEN: "timeline_filter_open",
  TIMELINE_FILTER_CLOSE: "timeline_filter_close",
  TIMELINE_FILTER_TURN_OFF_ATTRIBUTE_LEVEL_: "timeline_filter_turn_off_attribute_level_",
  TIMELINE_FILTER_TURN_ON_ATTRIBUTE_LEVEL_: "timeline_filter_turn_on_attribute_level_",
  TOGGLE_INFRARED_2D: "toggle_infrared_2D",
  ZOOM_IN: "zoom_in",
  ZOOM_OUT: "zoom_out",
};

export const GoogleAnalyticsConstantsCategory = {
  COLLECTION_CONTROLLER: "collection_controller",
  CONTEXT_MENU: "context_menu",
  CURATOR_HEADER_BAR: "curator_header_bar",
  CUSTOM_ELEMENTS_DETECTION: "custom_elements_detection",
  EXPORT_GEOTIFF: "export_geotiff_tool",
  HEADER_BAR: "header_bar",
  LEFT_TOOLBAR: "left_toolbar",
  MAP: "map",
  MEASUREMENT_TOOLBAR: "measurement_toolbar",
  PROPERTY_REPORT: "property_report",
  TIMELINE: "timeline",
  WIDGET: "widget",
  ZOOM_CONTROLLER: "zoom_controller",
};
